// Whisper theme — variant image swap
// Hooks into the native variant:update event to scroll the media gallery to the variant's assigned image

document.addEventListener('variant:update', (event) => {
  const variant = event.detail?.resource;
  if (!variant?.featured_media) return;

  const mediaId = variant.featured_media.id;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const targetSlide = gallery.querySelector(`[data-media-id="${mediaId}"]`);
  if (!targetSlide) return;

  targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
});
